import moment from 'moment';

export default function atom2datetime(atom, mode) {
  let input = moment(atom);
  let now = moment();
  let res = '';
  if (moment(input).isSame(now, 'year')) {
    if (moment(input).isSame(now, 'day')) {
      res += input.format("今日");
    }
    else if (moment(input).isSame(now.add(-1, 'days'), 'day')) {
      res += input.format("昨日");
    }
    else {
      res += input.format("M月D日");
    }
  }
  else {
    res += input.format("YYYY年M月D日");
  }
  if (mode.match(/T/)) {
    res += ' ';
    res += input.format("H:mm");
  }
  return res;
}
